import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';

function Boolean(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue); /// Bool casting

  value = value === 'false' ? false : value;
  value = value === 'true' ? true : value;
  value = !!value;

  if (props.style === 'dot') {
    return /*#__PURE__*/React$1.createElement("div", {
      className: "dot " + (value ? "active" : "")
    });
  }

  if (props.style === 'text') {
    return value ? props.trueText : props.falseText;
  }

  return value;
}

Boolean.defaultProps = {
  defaultValue: null,
  style: 'text',
  trueText: 'Yes',
  falseText: 'No'
};
Boolean.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any,
  style: PropTypes$1.oneOf(['text', 'dot']),
  trueText: PropTypes$1.node,
  falseText: PropTypes$1.node
};
var _Boolean = observer(Boolean);

export default _Boolean;
//# sourceMappingURL=Boolean.js.map
